import React from 'react';

import {
  WysiwygField,
} from '../../../components';

const TextBlock = ({ entity }) => {
  return (
    <>
      <h3>{entity.getIn(['info', 0, 'value'])}</h3>
      <WysiwygField
        property="schema:text"
        className="TextBlock"
        html={entity.getIn(['body', 0, 'processed'])}
      />
    </>
  );
};

export default TextBlock;
